import { createSelector } from "reselect";

export function createLoadStateRootSelector(resourceSelector) {
  return createSelector(
    resourceSelector,
    resource => resource.loadState
  );
}
